import { useNavigate } from "react-router-dom";
import Header from "../../../component/menu/Header";
import SideMenu from "../../../component/menu/SideMenu";
import { constants } from "../../../constant/constants";
import RecipeAddEditComponent from "../../../component/inventory/recipe/RecipeAddEditComponent";

export default function RecipeAdd() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col">
      <Header title={`McDonalds Food Chains`} menu={constants.MENU.INVENTORY} currentMenuKey={"T_7_S_7_L_5"} />
      <div className="flex flex-row bg-prewhite">
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.INVENTORY} />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <div className="flex items-center justify-between">
              <h1 className="pt-[26px] pb-[20px] font-bold text-black text-[24px] leading-[24px] cursor-default">
                Add Recipe
              </h1>
              <button
                className="w-[100px] h-[48px] bg-[#FCBD10] rounded-[5px] text-black font-bold leading-[15px] leading-[17px]"
                onClick={() => navigate("/inventory/recipe")}
              >
                List
              </button>
            </div>

            <div>
              <RecipeAddEditComponent />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
